import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { ItemMasterCreateForm } from '@/features/item/components/item-master-form'

export const Route = createFileRoute('/_app/inventory/master/create')({
	component: Component,
})

function Component() {
	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/master', 'Master Bahan'],
					[Route.fullPath, 'Tambah bahan baru'],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Tambah Bahan Baru" />
				<ItemMasterCreateForm />
			</PageCard.Root>
		</PageLayout.Root>
	)
}
